(function () {

    "use strict";

    angular
        .module("components")
        .component("hTabsBarComponent", {
            controller: TabsBarComponent,
            transclude: true,
            bindings: {
                selectedTabItem: '@',
                theme: '@',
                onTabClicked: '&?',
                tabsIds: '<?'
            },
            controllerAs: 'hTabsBarComponent',
            templateUrl: '../hmodules/components/h-tabs/tabs-bar/tabs-bar.component.html'
        });

    TabsBarComponent.$inject = ['$element', '$timeout', '$stateParams'];

    function TabsBarComponent($element, $timeout, $stateParams) {

        var self = this;

        self.addNewTabItem = function (item) {
            var isTabExist = false;

            for (var i in self.tabsBarItems) {
                var tab = self.tabsBarItems[i];

                if (tab.id === item.id) {
                    isTabExist = true;
                    break;
                }
            }

            if (!isTabExist) {
                if (isNaN(item.index)) {
                    self.tabsBarItems.push(item);
                }
                else {
                    var index = parseInt(item.index);
                    if (index < self.tabsBarItems.length) {
                        self.tabsBarItems.splice(index, 0, item);
                    }
                    else {
                        self.tabsBarItems.push(item);
                    }
                }

                changeActiveSlideForTabPosition();
            }
        };

        self.removeTab = function (tabId) {
            for (var i in self.tabsBarItems) {
                var tab = self.tabsBarItems[i];

                if (tab.id === tabId) {
                    self.tabsBarItems.splice(i, 1);

                    if (self.selectedTabItem === tab.id && self.tabsBarItems.length) {
                        self.onTabItemClicked(self.tabsBarItems[0]);
                    }
                    else {
                        changeActiveSlideForTabPosition();
                    }
                    break;
                }
            }
        };

        self.onTabItemClicked = function (tabItem) {
            if (self.onTabClicked({tabId: tabItem.id})) {
                self.selectedTabItem = tabItem.id;

                changeActiveSlideForTabPosition();
            }
        };

        self.$onChanges = function (changesObj) {
            if (
                typeof (changesObj.selectedTabItem) !== 'undefined' &&
                !changesObj.selectedTabItem.isFirstChange() &&
                changesObj.selectedTabItem.currentValue !== changesObj.selectedTabItem.previousValue
            ) {
                self.selectedTabItem = changesObj.selectedTabItem.currentValue;
                changeActiveSlideForTabPosition();
            }

            if ($stateParams.active_tab && self.tabsIds.indexOf($stateParams.active_tab) > -1) {
                self.selectedTabItem = $stateParams.active_tab;
            }
        };

        self.$onInit = function () {
            self.tabsBarItems = [];

            self.onTabClicked = self.onTabClicked || function (tadIdObject) {
                return true;
            };

            if (self.tabsBarItems[0] && self.tabsBarItems[0].id) {
                self.selectedTabItem = self.selectedTabItem || self.tabsBarItems[0].id;
            }

            self.themes = [
                'WIDE_TABS_BAR'
            ];
        };

        self.$postLink = function () {
            changeActiveSlideForTabPosition();
        };

        self.$onDestroy = function () {};

        var changeActiveSlideForTabPosition = function () {

            var theme = self.theme || 'DEFAULT_THEME';

            if (self.themes.indexOf(self.theme) === -1) {
                theme = 'DEFAULT_THEME';
            }

            $timeout(function () {
                if (self.selectedTabItem) {
                    $($element)
                        .find('.active-tab-border')
                        .show();

                    switch (theme) {
                        case 'DEFAULT_THEME':
                            var activeTab = $($element).find('li[id=' + self.selectedTabItem + '] a');

                            if (activeTab && activeTab.index() >= 0) {
                                $($element)
                                    .find('.active-tab-border').first()
                                    .css({
                                        width: activeTab.outerWidth(),
                                        left: activeTab.position().left
                                    });
                            }

                            break;
                        case 'WIDE_TABS_BAR':
                            var tabs = $($element).find('.h-tabs-bar').find('li');
                            var activeTab = $($element).find('li[id=' + self.selectedTabItem + ']');

                            tabs.removeClass('tabs-adjacent-active-tab');

                            if (activeTab && activeTab.index() >= 0) {
                                activeTab
                                    .prev()
                                    .addClass('tabs-adjacent-active-tab');
                            }

                            break;
                    }
                } else {
                    $($element)
                        .find('.active-tab-border')
                        .hide();
                }
            }, 150);
        };
    }
})();
